export enum AlertModalType {
  Info = 1,
  Warning = 2,
  Danger = 3,
  Success = 4,
  Question = 5,
}
